import FrequentlyAskedQuestions, {
  FaqParagraph,
  FrequentlyAskedQuestion,
} from './FrequentlyAskedQuestions';

export default FrequentlyAskedQuestions;
export { FrequentlyAskedQuestion, FaqParagraph };
